const CheckmarkIcon = ({ ...props }) => {
  return (
    <svg
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.5 5.375L1.5 3.375L0 4.875L3.5 8.375L10 1.875L8.5 0.375L3.5 5.375Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CheckmarkIcon;
